import { PER_PAGE } from '@const/pagination'
import { useGetFilialLimitHistoriesQuery } from '@services/filialLimitHistory'
import { SortStates } from '@templates/ListPageLayout/Filters/Sorter'
import useItemsFilters, { FilterState } from './useItemsFilters'

type Params = {
  initFilters?: FilterState
  pagination?: boolean
  limit?: number
  skip?: boolean
  initOrder?: { order: Record<string, SortStates> }
}

const useFilialLimitHistories = (params?: Params) => {
  const {
    initFilters = {},
    pagination = true,
    limit = PER_PAGE,
    skip,
    initOrder,
  } = params || {}
  const { filters, setFilters, setPage, setOrder } = useItemsFilters(
    initFilters,
    pagination,
    limit,
    initOrder
  )

  const state = useGetFilialLimitHistoriesQuery(filters, { skip })

  return {
    ...state,
    setPage,
    setFilters,
    setOrder,
  }
}

export default useFilialLimitHistories
